import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Card } from 'ui-components/components/card';
import { LegendItem } from './legend-item';
import { useFulfillmentDashboardContext } from '../../fulfillment-dashboard-context';
import { barData, barDataRaw, zeroValues, zeroValuesRaw } from './constants';

import { messages } from '../../messages';
import styles from './styles.module.less';
import { useSwitchFulfillmentDashboardToRawEndpoint } from '../../../../../feature-flags/hooks/use-switch-fulfillment-dashboard-to-raw-endpoint';

export const ShipmentStatusCard = () => {
  const { overviewData } = useFulfillmentDashboardContext();
  const shouldUseRawEndpoint = useSwitchFulfillmentDashboardToRawEndpoint();
  const statuses = overviewData.shipmentStatus || (shouldUseRawEndpoint ? zeroValuesRaw : zeroValues);
  const finalBarData = shouldUseRawEndpoint ? barDataRaw : barData;

  return (
    <Card>
      <FlexColumn gap={Gap.Space16}>
        <Text className={styles.bold} textType={TextType.H3} value={messages.shipmentStatus} />
        <ResponsiveContainer height={25} width='100%'>
          <BarChart data={[statuses]} layout='vertical'>
            <XAxis hide type='number' />
            <YAxis dataKey='name' hide type='category' />
            {finalBarData.map((b) => (
              <Bar key={b.dataKey} dataKey={b.dataKey} fill={b.fill} stackId={b.stackId} />
            ))}
          </BarChart>
        </ResponsiveContainer>
        <ul className={styles['legend-wrapper']}>
          {finalBarData.map((b) => (
            <LegendItem key={`legend-${b.dataKey}`} count={statuses[b.dataKey]} data={b} />
          ))}
        </ul>
      </FlexColumn>
    </Card>
  );
};
